import Vue from "vue";
import VueRouter from "vue-router";

//expatcare.co.kr, www.expatcare.co.kr 도메인인 경우.

Vue.use(VueRouter);

const routes = [
  {
  path: "/",
  component: () => import("@/page/Gijang/gijangcamp.vue"),
  meta: {
      title: "기장군민어학당",
    },
  },
  {
  path: "/notice",
  component: () => import("@/page/Gijang/Notice.vue"),
  meta: {
      title: "기장군민어학당",
    },
  },
  {
  path: "/schedule",
  component: () => import("@/page/Gijang/Schedule.vue"),
  meta: {
      title: "기장군민어학당",
    },
  },
  {
    path: "/gjrepresent",
    component: () => import("@/page/Gijang/Represent.vue"),
    meta: {
      title: "기장군민어학당",
    },
  },
  {
    path: "/popup",
    component: () => import("@/page/Gijang/Popup.vue"),
    meta: {
      title: "기장군민어학당",
    },
  },
];

const gijangcamp = new VueRouter({
  mode: "history",
  routes,
});

gijangcamp.afterEach((to, from) => {
  const title = to.meta.title === undefined ? "CarrotGlobal" : to.meta.title;
  Vue.nextTick(() => {
    document.title = title;
  });
});

export default gijangcamp;
